//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../no/Builder.js";
import "../GeometricUtilities/GeometricUtilities.DisplayResolutionBuilder.js";
import "../Validate/Validate.SelectionAndPlacementBuilder.js";
import "../no/ugmath.js";
import "../no/GeometricUtilities.js";
let d=[[[0,"AutomaticUpdate",1,0],[0,"CloseToPrintableVolumeColor",1,0],[1,"DisplayResolutionBuilder",0,"GeometricUtilities.DisplayResolutionBuilder",0],[0,"DistanceTolerance",1,0],[0,"OutOfPrintableVolumeColor",1,0],[0,"PreviewState",1,0],[0,"PrinterDiameter",1,0],[0,"PrinterHeight",1,0],[0,"PrinterLength",1,0],[0,"PrinterName",1,0],[0,"PrinterOrientation",1,0],[0,"PrinterOrigin",1,0],[0,"PrinterShapeType",1,0],[0,"PrinterWidth",1,0],[1,"SelectionAndPlacement",0,"Validate.SelectionAndPlacementBuilder",0],[0,"ShowType",1,0],[0,"WithinPrintableVolumeColor",1,0]],[],[]];
SPLM.Validate.CheckModelWithinPrintableVolumeBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Validate.CheckModelWithinPrintableVolumeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Validate.CheckModelWithinPrintableVolumeBuilder.PrinterShapeTypes = Object.freeze({
    "Block" : "Block", "Cylinder" : "Cylinder"});

SPLM.Validate.CheckModelWithinPrintableVolumeBuilder.ShowTypes = Object.freeze({
    "Printer" : "Printer", "Product" : "Product", "Both" : "Both"});

export default SPLM;